import { I18nMessages } from '../../../../libs/IdeLink.Web.Common/src/services/i18n/I18nMessages';

export const frOxylinkRenaming: I18nMessages = {
    //* LOGIN
    'app.name': 'Oxylink',
    'login.welcome': 'Bienvenue sur l’espace Oxylink !{br} Merci de vous connecter avec vos identifiants pour accéder à votre espace personnel et profiter du réseau Oxygo !',

    //* NAVBAR
    'navbar.videos': 'Vidéos',

    //* VIDEOS
    'videos.list.pageTitle': 'Vidéos',
    'videos.create.pageTitle': 'Création vidéo',
    'videos.create.tabs.informations.inputs.category.instantdigital': 'Vidéos',
    'videos.details.pageTitle': 'Détails vidéo',

    //* ACTUALITES
    'actualites.create.tabs.informations.inputs.category.product': 'Nouveautés produits',
    'actualites.create.tabs.informations.inputs.category.communication': 'On parle de nous',

    //* PERMISSIONS
    'backofficeUsers.create.tabs.permissions.sectionTabs.videos': 'Vidéo',
    'backofficeUsers.permissions.oxylinkgooddeals.contentcreate': 'Création de bon plan',

    'packagedOrders.product.multiPrice.normal_bought_price': 'PA HT:',
    'packagedOrders.product.multiPrice.normal_sell_price': 'PV TTC:',
    'packagedOrders.product.multiPrice.promo_bought_price': 'PA promo HT:',
    'packagedOrders.product.multiPrice.promo_sell_price': 'PV promo TTC:',

    'packagedOrders.product.dialog.multiPrice.normal_bought_price.label': 'PA HT:',
    'packagedOrders.product.dialog.multiPrice.normal_sell_price.label': 'PV TTC:',
    'packagedOrders.product.dialog.multiPrice.promo_bought_price.label': 'PA promo HT:',
    'packagedOrders.product.dialog.multiPrice.promo_sell_price.label': 'PV promo TTC:',
};
